import { render, staticRenderFns } from "./BasicCustomerInfo.vue?vue&type=template&id=08387981&scoped=true&"
import script from "./BasicCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./BasicCustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicCustomerInfo.vue?vue&type=style&index=0&id=08387981&prod&lang=css&"
import style1 from "./BasicCustomerInfo.vue?vue&type=style&index=1&id=08387981&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08387981",
  null
  
)

export default component.exports